module.exports = __webpack_public_path__ + "img/img_time@2x.1bdcc6ae.png";